module.exports = __webpack_public_path__ + "img/MEJOR.672a43d6.png";